import React from 'react';
import { Button } from 'primereact/button';

interface IconActionMenuButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  tooltip?: string;
}

const IconActionMenuButton: React.FC<IconActionMenuButtonProps> = ({
  onClick,
  disabled = false,
  tooltip,
}) => {
  return (
    <Button
      icon="pi pi-ellipsis-v"
      className="p-button-text p-button-rounded p-button-sm"
      style={{ color: '#334352', width: '1.9rem', height: '1.9rem' }}
      onClick={onClick}
      disabled={disabled}
      tooltip={tooltip}
      tooltipOptions={{ position: 'top' }}
      aria-label={tooltip}
    />
  );
};

export default IconActionMenuButton;
